function AccountDetailsController(){
	this.className	= "AccountDetailsController";
	this.glob		= "/account**";
	this.debug		= false;
};
AccountDetailsController.inheritsFrom( StandardController );
AccountDetailsController.prototype.setupPage = function(){
	console.log("AccountDetailsController: setupPage called");
};
AccountDetailsController.prototype.swap = function(){
	console.log('swap');
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
};
AccountDetailsController.prototype.on = function(){
	console.log('on')
	this.contactForm = new AccountDetailsForm();
	this.configButtons();
};
AccountDetailsController.prototype.off = function(){
	console.log('off')
	this.contactForm.destroy();
};
AccountDetailsController.prototype.configButtons = function() {
	// var formBlockElement = $('.js-form-block');
	// var contentBlockElement = $('.js-content-block');
	var formLabel = $('.js-form-label');
  var formItem = $('.js-form-item');
	var editButtonElement = $('.js-edit-button');
	var cancelButtonElement = $('.js-cancel-button');
	var confirmButton = $('.js-confirm-button');
  var cancelButton = $('.js-cancel-button');

	editButtonElement.on('click', Igloo.$d(this, function() {
		this.activateEditMode();
	}))
	
	cancelButtonElement.on('click', Igloo.$d(this, function() {
		this.deactivateEditMode();
	}))

	confirmButton.click(Igloo.delegate(this,function(event) {
		const licenceeId = $(event.target).data('licencee-id');
		console.log('licenceeId', licenceeId);
		const managerName = $(formItem[0]).find('input').val();
		const email = $(formItem[1]).find('input').val();
		const phone = $(formItem[2]).find('input').val();
		const notifications_email = $(formItem[3]).find('input').is(":checked");
		
		formLabel[0].innerHTML = managerName;
		formLabel[1].innerHTML = email;
		formLabel[2].innerHTML = phone;
		$(formLabel[3]).find('span')[0].innerHTML = notifications_email ? 'active' : 'inactive';

		// this.deactivateItemEditMode($(event.target));
		this.deactivateEditMode();

    this.submit(licenceeId, formItem).then(e => {
			console.log('done');
			// console.log(e);
			// console.log(formLabel);
      // newTeamMember.attr("data-staff-id",e.staffId);
    });

	}))
	
  cancelButton.on('click', Igloo.$delegate(this, function($this, event) {
    this.deactivateEditMode();
  }));

}

AccountDetailsController.prototype.submit = function(licenceeId, formItem) {
	let data = { licenceeId: licenceeId };
  var formItem = $('.js-form-item');
	formItem.each(function(){
		const item = $(this).find("input");
		const type = item.attr('type');
		if (type === 'checkbox') {
			data[item.attr("name")] = item.is(":checked") ? 1 : 0;
		} else {
			data[item.attr("name")] = item.val();
		}
	});
	return this.ajax(data);
}

AccountDetailsController.prototype.ajax = function(data) {
  return $.ajax({
    url: nav.getState().nextUrl,
    data: data,
    method: "post"
  }).then(e => {
    console.log(e);
		jcache.clearCache();
    return e;
  })
}

AccountDetailsController.prototype.activateEditMode = function() {
	var formLabel = $('.js-form-label');
  var formItem = $('.js-form-item');
	var confirmCancelBlock = $('.js-confirm-cancel-block');
	var sideBlockElement = $('.js-side-block');
	
  formLabel.addClass('hide');
  formItem.removeClass('hide');
  confirmCancelBlock.removeClass('hide');
	sideBlockElement.addClass('hide');

	const managerName = $(formItem[0]).find('input');
	const email = $(formItem[1]).find('input');
	const phone = $(formItem[2]).find('input');
	
	managerName.val(formLabel[0].innerHTML);
	email.val(formLabel[1].innerHTML);
	phone.val(formLabel[2].innerHTML);
}

AccountDetailsController.prototype.deactivateEditMode = function() {
	var formLabel = $('.js-form-label');
	var formItem = $('.js-form-item');
	var confirmCancelBlock = $('.js-confirm-cancel-block');
	var sideBlockElement = $('.js-side-block');
	
	formLabel.removeClass('hide');
	formItem.addClass('hide');
  confirmCancelBlock.addClass('hide');	
	sideBlockElement.removeClass('hide');
}